export default {
	'sign_out': 'Sign Out',
	'notification_error': 'Error'
};